import React from "react";
import { createAttributeHeightFix } from "../image";

const Template2 = (props) => {
  const { src, width, height } = createAttributeHeightFix(
    420,
    props.image_path,
    props.items.image.images[0] ?? {},
  );

  return (
    <div className="popup-box--banner">
      <div className="popup-box__figure">
        <a
          href={props.items.url.url}
          onClick={(e) => {
            /** @see https://github.com/wdpk-plus-creation/webtk/blob/develop/resources/assets/js/admin/common_preview.js#L1 */
            if (!window?.preview) {
              props.handleTrackingCt(e);
            }
          }}
        >
          <img
            className="popup-box__figure-img"
            src={src}
            width={width}
            height={height}
            alt=""
          />
        </a>
      </div>
      <button className="popup-box__close" onClick={props.handleClose} />
    </div>
  );
};

export default Template2;
